<span class="rmb">￥</span
><span class="price" [ngStyle]="{color}">{{ price | number }}</span>
